import { RateGroupSettlementAction, RateGroupSettlementType } from '@mews/enums';

interface IsImmediatelySettledOptions {
    settlementType: RateGroupSettlementType;
    isTriggeredOnConfirmation: boolean;
}

export const isImmediatelySettled = ({
    isTriggeredOnConfirmation,
    settlementType,
    action,
}: IsImmediatelySettledOptions & { action: RateGroupSettlementAction }) =>
    settlementType === RateGroupSettlementType.Automatic &&
    isTriggeredOnConfirmation &&
    action === RateGroupSettlementAction.ChargeCreditCard;

export const isImmediatelySettledWithPreauthorizations = ({
    isTriggeredOnConfirmation,
    settlementType,
}: IsImmediatelySettledOptions) => settlementType === RateGroupSettlementType.Automatic && isTriggeredOnConfirmation;
